/**
 * ExportBar — reusable CSV + PDF export buttons
 * Usage: <ExportBar onCSV={handleCSV} onPDF={handlePDF} label="Players" />
 */
import { Download, Printer } from 'lucide-react';

export default function ExportBar({ onCSV, onPDF, label = 'Data', className = '' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {onCSV && (
        <button
          onClick={onCSV}
          title={`Export ${label} as CSV`}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold text-[#22c55e] bg-[rgba(34,197,94,0.08)] border border-[rgba(34,197,94,0.3)] hover:bg-[rgba(34,197,94,0.15)] transition-colors whitespace-nowrap"
        >
          <Download className="h-3.5 w-3.5" />
          CSV
        </button>
      )}
      {onPDF && (
        <button
          onClick={onPDF}
          title={`Print / Save ${label} as PDF`}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold text-[#8a93a3] bg-[#161a26] border border-[#252a37] hover:text-[#f0f2f7] hover:border-[rgba(255,255,255,0.2)] transition-colors whitespace-nowrap"
        >
          <Printer className="h-3.5 w-3.5" />
          PDF
        </button>
      )}
    </div>
  );
}
